import SocketManager from '../../lib/controller-ws/socket-manager';
import AcceptCallMessage from '../../lib/controller-ws/messages/accept-call';
import EndCallMessage from '../../lib/controller-ws/messages/end-call';
import TextMessage from '../../lib/controller-ws/messages/text';
import moment from 'moment';

import M from '../mutation-types';

let socket;

export default function webSocketPlugin(store) {
	socket = new SocketManager(store._vm);

	socket.on('message.authenticate', (message) => {
		if (message.authenticated && message.permissionConsole) {
			store.commit('videoCall/set_connected', true);
		} else {
			socket.close();
			store.commit(M.SET_ERROR, 'Unable to login to call management server.', {root: true});
		}
	});

	socket.on('message.error', ({errorText}) => {
		if (/is no longer in system$/.test(errorText)) {
			socket.close();
			store.commit(M.SET_ERROR, 'This call has already ended.', {root: true});
		} else if (/^Call already answered by/.test(errorText)) {
			socket.close();
			store.commit(M.SET_ERROR, errorText, {root: true});
		} else {
			socket.close();
			store.commit(M.SET_ERROR, 'An error has occured while answering this call: ' + errorText, {root: true});
		}
	});

	socket.on('message.callerStatus', (message) => {
		if (message.callerID !== store.state.callerId) {
			return;
		}

		store.commit('videoCall/update_status', message);
	});

	socket.on('message.location', (message) => {
		store.commit(M.VIDEOCALL_UPDATE_USER_LOCATION, {lat: message.latitude, lng: message.longitude});
	});

	socket.on('message.profile', message => {
		store.commit(M.UPDATE_PROFILE, message);
	});

	socket.on('message.text', (message) => {
		store.commit('videoCall/chat_messages/add_remote', message);
	});

	socket.on('hangup', () => {
		socket.close();
		store.commit(M.SET_ERROR_TITLE, 'Call Ended', {root: true});
		store.commit(M.SET_ERROR, `Call with ${store.state.callerId} has ended.`, {root: true});
	});

	socket.on('send_ice_servers_request', (request) => {
		socket.send(request);
	});

	socket.on('on_ice_candidate', (request) => {
		socket.send(request);
	});
	socket.on('on_offer', (request) => {
		socket.send(request);
	});
	socket.on('on_answer', (request) => {
		socket.send(request);
	});

	store.subscribe((mutation, state) => {
		switch (mutation.type) {
		case M.OPERATOR_SET_DATA:
			// Once we know the operator information,
			// we have everything we need to try to begin the call.
			store.commit('show_loader');
			socket.url = state.controller.replace('http', 'ws') + '/console';
			socket.connect(state.operator.rawToken);
			break;
		case 'videoCall/set_connected':
			store.dispatch('videoCall/try_answer_call');
			break;
		case 'videoCall/answer':
			socket.send(new AcceptCallMessage({callerID: state.callerId}));
			break;
		case 'videoCall/update_status':
			if (state.videoCall.answered_by === store.getters['operator/controllerUserId']) {
				store.commit('hide_loader', {root: true});
			} else if (state.videoCall.answered_by !== '') {
				// Someone else answered the call
				store.commit(M.SET_ERROR, 'Another operator has answered this call', {root: true});
			}
			break;
		case 'videoCall/chat_messages/add_local':
			if (socket.is_open) {
				// We need to create a new object since the server doesn't support real ISO timestamp format.
				socket.send(new TextMessage({
					source: mutation.payload.source,
					destination: mutation.payload.destination,
					message: mutation.payload.message,
					timestamp: mutation.payload.timestamp.toISOString().replace(/z|t/gi,' ').trim(),
				}));
			}
			break;
		case 'videoCall/endCall':
			if (socket.is_open) {
				socket.send(new EndCallMessage({callerID: state.callerId}));
			}
			break;
		}
	});
}

export function makeMessage(store, message, fromLocal, timestamp) {
	let local = store.getters['operator/controllerUserId'];
	let remote = store.state.callerId;

	return {
		source: fromLocal ? local : remote,
		destination: fromLocal ? remote : local,
		message: message,
		timestamp: moment(timestamp),
	};
}
